export const Paths = {
  HOME: "/",
  LOGIN: "/login",
  AUTH_CALLBACK: "/auth/callback",
  REQUEST_ACCESS: "/solicitar-acesso",
  NOT_FOUND: "/404",
  FORBIDDEN: "/sem-permissao",

  CONTROL_PANEL: "/painel-de-controle",
  CONTROL_PANEL_PERMISSIONS: "/painel-de-controle/permissoes",
  CONTROL_PANEL_PERMISSION_EDIT: "/painel-de-controle/permissoes/:id/editar",
  CONTROL_PANEL_USERS: "/painel-de-controle/usuarios",
  CONTROL_PANEL_ROLES: "/painel-de-controle/perfis",
  CONTROL_PANEL_AUDIT: "/painel-de-controle/auditoria",

  EMBARCACOES: "/embarcacoes",

  RECURSOS: "/recursos",
  RECURSOS_PROFISSIONAIS: "/recursos/profissionais",
  RECURSOS_CARGA_DE_TRABALHO: "/recursos/carga-de-trabalho",

  /** Painel de Obras — aba Detalhamento (HU 2521). */
  OBRAS: "/obras",
  OBRAS_NOVA: "/obras/nova",

  /** Financeiro — abas Obras (HU 2670) e Configurações. `/financeiro` redireciona para Obras. */
  FINANCEIRO: "/financeiro",
  FINANCEIRO_OBRAS: "/financeiro/obras",
  FINANCEIRO_CONFIGURACOES: "/financeiro/configuracoes",
  FINANCEIRO_CONFIGURACOES_CURVAS: "/financeiro/configuracoes/curvas",
  FINANCEIRO_CONFIGURACOES_DISTRIBUICOES: "/financeiro/configuracoes/distribuicoes",
  FINANCEIRO_CONFIGURACOES_BASE_DADOS: "/financeiro/configuracoes/base-dados",
  FINANCEIRO_CONFIGURACOES_MOEDAS: "/financeiro/configuracoes/moedas",
  FINANCEIRO_CONFIGURACOES_ESCOPOS_PADRAO: "/financeiro/configuracoes/escopos-padrao",

  // -- Adicionar rotas de domínio conforme implementação --
  // OBRAS_DETAIL: "/obras/:id",
} as const;

export function buildPermissionEditPath(id: string): string {
  return Paths.CONTROL_PANEL_PERMISSION_EDIT.replace(":id", encodeURIComponent(id));
}

/** Listagem de usuários, opcionalmente já filtrada pelo perfil (papelId). */
export function buildUsersPath(filters?: { papelId?: string }): string {
  const params = new URLSearchParams();
  const papelId = filters?.papelId?.trim();

  if (papelId) params.set("papelId", papelId);

  const query = params.toString();
  return query ? `${Paths.CONTROL_PANEL_USERS}?${query}` : Paths.CONTROL_PANEL_USERS;
}
